import React, { useLayoutEffect, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
import {
  getBreadcrumbsAndTitle,
  useSubheader,
} from "../../_core/MetronicSubheader";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { FontAwesomeIcon } from "../../../../../../../CommonComponents/AssetsHelper";

export function NavigationHeader(props) {
  const uiService = useHtmlClassService();
  const location = useLocation();
  const subheader = useSubheader();

  useLayoutEffect(() => {
    const aside = getBreadcrumbsAndTitle("kt_aside_menu", location.pathname);
    const header = getBreadcrumbsAndTitle("kt_header_menu", location.pathname);
    const breadcrumbs =
      aside && aside.breadcrumbs.length > 0
        ? aside.breadcrumbs
        : header.breadcrumbs;
  }, [location.pathname]);

  useEffect(() => {}, [subheader]);

  return (
    <div className="subheader">
      <div className="d-flex align-items-center">
          <Link className="p-3 border-end me-3" onClick={() => props.goBackNavigation ? props.goBackNavigation() : null}
            to={props.backToNavigation ? props.backToNavigation : "#"}>
            <FontAwesomeIcon type={'regular'} icon={'angle-left'} iconClass={'fs-5'} />
          </Link>
          <h5 className="my-3 text-nowrap overflow-hidden">
            {props.name}
          </h5>
        </div>
    </div>
  );
}
